import { useQuery } from '@tanstack/react-query';
import { http } from '@/shared/api/http';
import { useAuth } from '@/features/auth/auth-store';

export interface OrgSummary {
  id: string;
  name: string;
  subscription?: {
    days_until_expiry: number;
  };
}

export function useOrg() {
  const { user } = useAuth();
  return useQuery<OrgSummary>({
    queryKey: ['org', user?.id],
    enabled: !!user,
    queryFn: () => http<OrgSummary>('/org'),
    staleTime: 60_000,
  });
}
